import { useContext } from 'react';

import AuthorizationContext from 'packages/kakapo-ui-application/contexts/AuthorizationContext';

/**
 * Return the current authenticated user.
 */
export default function useAuthenticatedUser() {
	const { authenticatedUser } = useContext(AuthorizationContext)!;

	return authenticatedUser;
}
